import React, { Component } from "react";
import PropTypes from "prop-types";
import { autobind } from "core-decorators";
import { NonIdealState, Button } from "@blueprintjs/core";
import axios from "axios";

class Display extends Component {
  constructor(props) {
    super(props);
    this.state = {
      has_display: false,
      refreshScreenshot: Math.floor(Math.random() * 10000),
    };
  }

  componentDidMount() {
    this.updateDisplayStatus();
  }

  componentDidUpdate(prevProps) {
    const { nvr } = this.props;
    if (nvr) {
      if (!prevProps.nvr || nvr.hostname !== prevProps.nvr.hostname) {
        this.updateDisplayStatus();
      }
    }
  }

  @autobind
  updateDisplayStatus() {
    const { nvr } = this.props;
    if (nvr && nvr.hostname) {
      axios
        .get(`https://${nvr.hostname}/ping`, {
          headers: { Authorization: `Bearer ${nvr.access_token}` },
        })
        .then((response) => {
          this.setState({
            has_display: response.data.display_status,
          });
        });
    }
  }

  @autobind
  refresh() {
    this.setState({ refreshScreenshot: Math.floor(Math.random() * 10000) });
  }

  render() {
    const { nvr } = this.props;
    const { has_display, refreshScreenshot } = this.state;
    if (!has_display) {
      return (
        <div>
          <NonIdealState icon="presentation" title="Display is not connected" />
        </div>
      );
    }
    return (
      <div>
        <div className="column has-text-right">
          <Button onClick={this.refresh}>Refresh</Button>
        </div>
        <img
          src={`https://${nvr.hostname}/nvr/v1/system/screenshot?access_token=${nvr.access_token}&${refreshScreenshot}`}
          alt="Screenshot"
        />
      </div>
    );
  }
}

Display.propTypes = {
  nvr: PropTypes.object,
};

export default Display;
